export const config = {

    apiUrl: 'https://hajcp.d-pioneers.com/api/',
    apiUrl2: 'https://hajcp.d-pioneers.com/',


    authRoles: {
        sa: ['SA'], // Only Super Admin has access
        admin: ['SA', 'Admin'], // Only SA & Admin has access
        editor: ['SA', 'Admin', 'Editor'], // Only SA & Admin & Editor has access
        user: ['SA', 'Admin', 'Editor', 'User'], // Only SA & Admin & Editor & User has access
        guest: ['SA', 'Admin', 'Editor', 'User', 'Guest'] // Everyone has access
    }
}


//apiUrl: 'https://hajcp.d-pioneers.com/api/',
//    apiUrl2: 'https://hajcp.d-pioneers.com/',

//    apiUrl: 'http://localhost:5161/api/',
//    apiUrl2: 'http://localhost:5161/',
